import { XMLCodePrettifier } from './XMLCodePrettifier';

export default XMLCodePrettifier;